module.exports = __webpack_public_path__ + "img/pdficon.55afad89.svg";